<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let link of form?.controls; let i = index">
    <div class="link-container-fields">
      <mat-form-field [class.error]="link?.controls?.url.invalid && (link?.controls?.url.dirty || link?.controls?.url.touched)">
        <input
          matInput
          required
          placeholder="Url"
          formControlName="url">
        <mat-icon
          class="link-open"
          matSuffix>
          <a
            target="_blank"
            rel="noopener"
            [href]="link?.value?.url">
            open_in_new
          </a>
        </mat-icon>
        <mat-error class="message-error">{{ 'Url obbligatorio' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Titolo"
          formControlName="titolo">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Descrizione"
          formControlName="descrizione">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Tipo"
          formControlName="tipo">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi link' | translate }}
  </button>
</div>
